import { motion } from 'framer-motion'
import Header from './header'
import MenuItem from './menuItem'

const DesktopMenu = ({ openMenu, setOpenMenu, hideEventsPage }) => {
  const base =
    'fixed top-0 left-0 z-50 w-full h-[100svh] bg-dune overflow-hidden flex flex-col scrollbar-hidden'

  const initial = {
    height: 0,
  }
  const animate = openMenu ? { height: '100svh' } : { height: 0 }

  const transition = { duration: 0.5 }

  return (
    <motion.div
      initial={initial}
      animate={animate}
      transition={transition}
      className={base}
    >
      <Header onClick={() => setOpenMenu(!openMenu)} />
      <MenuItem onClick={() => () => setOpenMenu(false)} hideEventsPage={hideEventsPage} />
    </motion.div>
  )
}

export default DesktopMenu
